export default {
  devices: state => {
    return state.devices;
  },
  roamingDevices: state => {
    return state.roamingDevices;
  },
  deviceById: state => id => {
    if (state.devices) {
      const filter = state.devices.filter(item => {return parseInt(item['id']) === parseInt(id);});
      if (filter && filter.length > 0) {
        const device = filter[0];
        device['childDevices'] = state.devices.filter(item => {
          return parseInt(item['parent_id']) === parseInt(id);
        });

        return device;
      }
    }

    return null;
  },
  devicesByIntegrationId: state => integrationId => {
    return state.devices.filter(item => {
      return parseInt(item.integration_id) === parseInt(integrationId);
    });
  },
  deviceByTopicId: state => topicId => {
    const filteredTopic = state.deviceTopics.filter(item => {
      return parseInt(topicId) === parseInt(item.id);
    });

    if (filteredTopic.length > 0) {
      const filtered = state.devices.filter(item => {
        return parseInt(item.id) === parseInt(filteredTopic[0].device_id);
      });

      return filtered.length > 0 ? filtered[0] : null;
    }

    return null;
  },
  deviceTopicById: state => topicId => {
    const filtered = state.deviceTopics.filter(item => {
      return parseInt(topicId) === parseInt(item.id);
    });

    return filtered.length > 0 ? filtered[0] : null;
  },
  networkTypes: state => {
    return state.networkTypes;
  },
  deviceTypes: state => {
    return state.deviceTypes;
  },
  manufacturers: state => {
    return state.manufacturers;
  },
  deviceTopics: state => {
    return state.deviceTopics;
  },
  deviceEndpoints: state => {
    return state.deviceEndpoints;
  },
  topicsByDeviceId: state => id => {
    return state.deviceTopics.filter(item => {
      return parseInt(item.device_id) === parseInt(id);
    });
  }
};